
import { useState, useCallback } from 'react';

/**
 * Hook that tracks which fields have been modified by the user
 */
export const useFieldModification = () => {
  // Store modified fields in state
  const [modifiedFields, setModifiedFields] = useState<Record<string, boolean>>({});
  
  // Mark a field as modified
  const markFieldAsModified = useCallback((fieldName: string) => {
    setModifiedFields(prev => ({
      ...prev,
      [fieldName]: true
    }));
  }, []);
  
  // Reset a field's modified status
  const resetFieldModified = useCallback((fieldName: string) => {
    setModifiedFields(prev => ({
      ...prev,
      [fieldName]: false
    }));
  }, []);
  
  // Check if a field has been modified
  const isFieldModified = useCallback((fieldName: string): boolean => {
    const isModified = Boolean(modifiedFields[fieldName]);
    return isModified;
  }, [modifiedFields]);
  
  return {
    markFieldAsModified,
    resetFieldModified,
    isFieldModified
  };
};
